import {
  REQUEST_MERCHANT_LIST,
  REQUEST_MERCHANT,
  REQUEST_MERCHANT_CATEGORY_LIST,
} from './mutation-types'

import axiosInst from '@/utility/axiosInst';

export default {
  requestMerchantList({commit}, payload) {
    const {currentPage, searchType, searchWord} = payload
    return axiosInst.springAxiosInst.get("/admin/merchant/merchant-list", {
      params: {
        page: currentPage,
        searchType: searchType,
        searchWord : searchWord
      }
    }).then((res) => {
      commit(REQUEST_MERCHANT_LIST, res.data)
    })
  },

  requestMerchant({commit}, authSeq) {
    return axiosInst.springAxiosInst.get(`/admin/merchant/merchant/${authSeq}`)
    .then((res) => {
      commit(REQUEST_MERCHANT, res.data)
    })
  },

  requestMerchantEdit({}, payload) {
    return axiosInst.springAxiosInst.post(`/admin/merchant/merchant-edit/${payload.get("authSeq")}`, payload)
    .then((res) => {
      return res.data
    })
  },

  requestSaveMerchant({}, payload) {
    console.log('requestSaveMerchant', payload);
    return axiosInst.springAxiosInst.post("/admin/merchant/save-merchant", payload)
      .then((res) => {
        return res.data
      })
  },

  requestMerchantCategoryListForCreate({commit}) {
    return axiosInst.springAxiosInst.get('/admin/merchant/get-all-categories', {
    }).then((res) => {
      commit(REQUEST_MERCHANT_CATEGORY_LIST, res.data)
    })
  },

}